export default __webpack_public_path__ + "static/media/btmBg.e78b5489.png";